import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsSection } from './components/StatsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainSolutionSection } from './components/PainSolutionSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { LivePopup } from './components/LivePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(t, firstScript);
    } else {
      document.head.appendChild(t);
    }
    w.fbq('init', '1106155782586740');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-black font-sans selection:bg-brand selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <StatsSection data-id="element-2" />
      <TestimonialsSection data-id="element-3" />
      <PainSolutionSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <Footer data-id="element-9" />
      <LivePopup data-id="element-10" />
    </div>;
}